export class DisclosureConstant {
  static readonly COMPLETE: string = 'COMPLETE'
  static readonly REVISION: string = 'REVISION'
  static readonly OPEN: string = 'Open'
}
